export * from './Guid';
export * from './Money';
export * from './OptionsetItem';
export * from './EntityReference';
export * from './BaseEntity';



// WEBPACK FOOTER //
// ./src/app/schemas/codegen/base/base.ts